import { BrowserRouter as Router } from "react-router-dom";
import RouteManager from "route-manager/index";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Toaster from "common/Toast";
import { ConfirmDialog } from "primereact/confirmdialog";

function App() {
  const basename = process.env.PUBLIC_URL;

  console.log("App basename:", basename);
  return (
    <Router basename={basename}>
      <div className="h-full">
        {/* Global ConfirmDialog */}
        <ConfirmDialog />
        <RouteManager />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
